/* eslint-disable complexity */
import React from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';
import strings from '../../utils/strings';
import './styles.scss';
import Logo from 'assets/logo-white.png';
import getTestKeyInfo from 'api/getTestKeyInfo';
import {initAuthAction} from 'actions/index';

import {authCallback} from 'utils/bankIdLogin';

import {FEIDE, IS_NORMING_VERSION} from 'constants/index';

import loginNoAuth from 'api/loginNoAuth';
import CustomLogin from '../CustomLogin';

const parsedSearch = queryString.parse(window.location.search);
const search = parsedSearch;
const params = new URLSearchParams(search);

const testKey = parsedSearch.key;
const id = params.get('id');

const authSuccess = parsedSearch.authSuccess;
function IsValidJSONString(str) {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
}

const styles = {
	errorMessage: {
		color: 'yellow',
		fontSize: '18px',
		overflowWrap: 'break-word',
	},
	errorTitle: {
		fontWeight: 'bold',
		color: '#ff6600',
		textShadow: 'black 1px 1px 1px',
		fontSize: '20px',
		marginRight: '3px',
		overflowWrap: 'break-word',
	},
	thirdPartyMessage: {
		color: 'white',
		margin: 'auto',
		textAlign: 'center',
		fontSize: '18px',
	},

	reuseBanner: {                   // NEW
    background: '#0b3d3f',
    border: '1px solid #1fb6ad',
    color: 'white',
    padding: '10px 12px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'start',
    gap: '10px',
    textAlign: 'left',
    maxWidth: 800,
    margin: '10px auto 0',
  },
  reuseDot: { // NEW
    flex: '0 0 auto',
    width: 10,
    height: 10,
    borderRadius: '999px',
    background: '#1fb6ad',
    marginTop: 6,
  },
  reuseClose: { // NEW
    marginLeft: 'auto',
    background: 'transparent',
    border: 'none',
    color: '#b2f5ea',
    cursor: 'pointer',
    fontSize: '16px',
  },
};

/* const flag = JJiisTezRREXXDSSERllliOR321Frrsaas */
class Login extends React.Component {
	constructor() {
		super();

		this.state = {
			userPin:null,
			isLoginVisible: true,
			passwordLogin: false,
			email: null,
			pinCode: null,
			childSelfStarting: null,
			isNorming:null,
			showCoockieDetectionFrame: false,
			showAltLogin:
				/* id === 'JJiisTezRREXXDSSERllliOR321Frrsaas' || */
				id === 'child-exp-oms-test' ? true : false,
			altError: null,
			isFeide:false,
			instructions:null,
			requiresVerification:null,
			initialPin:null,
			dispatchAddress:null,
			testStatus:null,
			reuseSignal: null, // NEW
      		showReuseBanner: false, // NEW
			bootstrapping: true,
		};
	}
	 

	componentDidMount() {
		window.localStorage.removeItem('authtoken-screening');

		if (!testKey) {
			window.location.href = `/?error=true`;
			return;
		}

		// eslint-disable-next-line vars-on-top
		var receiveMessage = function (evt) {
			if (evt.data === 'MM:3PCunsupported') {
				document.getElementById('lit-site-warning').innerHTML =
					strings.warning2;
				document.getElementById('lit-site-warning_text').innerHTML =
					strings.warning2text;
				document.getElementById(
					'lit-site-settings-instructions'
				).innerHTML = strings.linkForInstructions;
				document.getElementById('lit-site-warning_text_end').innerHTML =
					strings.warning_text_end;
			} else if (evt.data === 'MM:3PCsupported') {
				document.getElementById('result').innerHTML = '';
			}
		};
		window.addEventListener('message', receiveMessage, false);

		getTestKeyInfo(testKey).then((response) => {

			if (!response) {
				console.error('No response received for test key:', testKey);
				return;
			  }

			const { reuseSignal } = response || {};  // NEW
			console.log('This is the reuseSignal', reuseSignal);
			const near = Boolean(reuseSignal && reuseSignal.nearSimultaneous);


			  const {
				email: rawEmail,
				initialPin,
				dispatchAddress,
				childSelfStarting,
				requiresVerification,
				isDistributed,
				isNorming,
				status,
			  } = response;


			  const email = rawEmail || dispatchAddress;
			  const normingFlag = isNorming === 1;
			  const distributedFlag = Boolean(isDistributed);
			  let instructionsText = null;

			if (status !== 'isCompleted' && requiresVerification) {
				instructionsText = (
					<p className="lit-verify-note">
				  <span>
					Denne testen er eldre enn en måned. For å sikre ditt personvern må vi bekrefte at det er riktig bruker
					starter testen. Vennligst bruk pinkoden som vi har sendt til{' '}
					<span style={{ color: 'white' }}>
					  <i>
						<u>{dispatchAddress}</u>
					  </i>
					</span>{' '}
					for å starte testen.
				  </span>
				  </p>
				);
			  }

			  if (status === 'isUsed') {
				instructionsText = (
					<p className="lit-verify-note">
						 <span>
					Denne testen er startet før, men ikke fullført. For å sikre ditt personvern må vi bekrefte at det er
					riktig bruker starter testen. Vennligst bruk pinkoden som vi har sendt til{' '}
					<span style={{ color: 'white' }}>
					  <i>
						<u>{dispatchAddress}</u>
					  </i>
					</span>{' '}
					for å starte testen.
				  </span>
					</p>
				 
				);
			  }

			 const errorToThrow =
      status === 'isCompleted'
        ? 'Denne testen er allerede fulført'
		: null;
		this.setState({
			email,
			pinCode: initialPin,
			childSelfStarting,
			requiresVerification, 
			pinLogin: Boolean(instructionsText),
			initialPin,
			isNorming: normingFlag,
			dispatchAddress,
			altError: errorToThrow,
			instructions: instructionsText,
			isDistributed: distributedFlag,
			reuseSignal, // NEW
  			showReuseBanner: near, // NEW
		  });
		  
		}).catch((response) => {
			response.json().then((error) => {
			  const altErrorMessage =
				error.error === 'pincode instead'
				  ? 'Det ser ut til at du bruker pinkode i stedet for testnøkkel for å starte testen.'
				  : 'Testnøkkelen er ikke gyldig eller allerede brukt.';
		
			  this.setState({
				altError: altErrorMessage,
			  });
			});
		  }).finally(() => {
    this.setState({ bootstrapping: false }); // NEW
		
		  });

		if (authSuccess) {
			let data = atob(
				decodeURIComponent(
					window.location.search.substr(
						window.location.search.indexOf('=') + 1
					)
				)
			);

			if (data && IsValidJSONString(data)) {
				// eslint-disable-next-line consistent-return
				return new Promise((resolve, reject) => {
					data = JSON.parse(data);

					if (data.authError) {
						reject({message: 'There was an error logging you in'});
						return;
					}

					if (
						data &&
						data.action === 'auth' &&
						data.result === 'OK'
					) {
						localStorage.setItem('authtoken-screening', data.authToken);

						window.location.href = `/test`;
						resolve();
						return;
					}
					reject({message: `Kunne ikke logge inn!`});
				});
			} 
		}
	}

	dismissReuseBanner = () => { // NEW
    this.setState({ showReuseBanner: false });
  };

    formatSince(mins) {  // NEW - optional nicety
    if (typeof mins !== 'number' || mins < 0) return '';
    if (mins < 1) return 'nå nettopp';
    if (mins === 1) return 'for 1 minutt siden';
    if (mins < 60) return `for ${mins} minutter siden`;
    return 'for kort tid siden';
  }


	reAffirmTestKeyInfo(testKey) {
		getTestKeyInfo(testKey).then((response) => {
			const email = response.email;
			const pinCode = response.pinCode || this.state.initialPin;
			const childSelfStarting = response.childSelfStarting;
			this.setState({
				email,
				pinCode,
				childSelfStarting,
				passwordLogin: true,
				pinLogin: false,
				showCoockieDetectionFrame: false,
			});
		});
	}

	initializeAltLogin = () => {
		// eslint-disable-next-line no-invalid-this
		this.setState({
			showAltLogin: true,
		});
	};
	onAltLoginFieldChange = (e) => {
		// eslint-disable-next-line no-invalid-this
		this.setState({
			[e.target.name]: e.target.value,
		});
	};
	submitAltLogin = (e) => {
		e.preventDefault();
		const {firstName, lastName} = this.state;
		const data = {testKey, firstName, lastName};

		loginNoAuth(data)
			.then((results) => {
				authCallback({data: JSON.stringify(results)});
			})
			.catch(() => {
				this.setState({
					altError: 'Ikke gyldig testnøkkel',
				});
			});
	};

	// eslint-disable-next-line space-before-blocks
	comparePinCodes(){
		if (this.state.initialPin.toLowerCase() === this.state.userPin.toLowerCase()) {
			this.setState({
				requiresVerification:false,
				instructions:null
			});

		}
		else {
			this.setState({
				altError:'Feil pinkode. Testen kan ikke startes'
			});
		}
	}

	render() {
		const {
			bootstrapping,
			isLoginVisible,
			showAltLogin,
			altError,
			isFeide,
			isNorming,
			requiresVerification,
			passwordLogin,
			showCoockieDetectionFrame,
			instructions,
			email,
			pinCode,
			childSelfStarting,
			pinLogin
		} = this.state;

		const reqKnown = typeof requiresVerification === 'boolean';
		const reqRequired = requiresVerification === true;
		const reqNotRequired  = requiresVerification === false;
	
		const {error, iframeUrl, initAuth, isInit} = this.props;
	
		const showIframe = isInit && iframeUrl && !showAltLogin;
		const showError = isInit && error && !showAltLogin;
		const showLoginButtons = !isInit && !showAltLogin;
	
		if (!isLoginVisible) return null;
	
		// Redirect if Feide and iframe
		if (showIframe && isFeide) {
			window.location.href = `${iframeUrl}`;
		}

		const showCustomLogin =
  Boolean(passwordLogin) ||
  Boolean(pinLogin && email && requiresVerification);

  const canShowChoiceButtons =
  !bootstrapping &&
  reqNotRequired &&
  !passwordLogin &&
  !altError &&
  !isNorming &&
  !showCustomLogin;

		const renderErrorOrInstructions = () => {
			if (altError) {
				return (
					<div>
						<br />
						<span className="error" style={styles.errorMessage}>
							<span style={styles.errorTitle}><i>Error: </i></span>
							{altError}
						</span>
					</div>
				);
			}
			if (instructions) {
				return (
					<div>
						<br />
						<span className="error" style={styles.errorMessage}>
							<span style={styles.errorTitle}><i>{' '}</i></span>
							{instructions}
						</span>
					</div>
				);
			}
			return null;
		};
	
		const renderFeidePincodeButtons = () => (
			<div className="bank-id-type-selector-wrapper">
				<button
					className="lit-btn lit-btn--small bg-secondary"
					onClick={() => {
						this.setState({ showCoockieDetectionFrame: true, isFeide: true });
						initAuth(FEIDE, testKey, false);
					}}
				>
					Feide
				</button>
				<button
					className="lit-btn lit-btn--small bg-secondary"
					onClick={() => this.reAffirmTestKeyInfo(testKey)}
				>
					Pinkode
				</button>
				
			</div>
		);
	
		const renderAltLoginForm = () => (
			<div className="alternate-login">
				<p>For å logge inn uten BankID eller Feide trenger vi å vite hva du heter</p>
				<form onSubmit={this.submitAltLogin}>
					<label>
						Fornavn
						<input type="text" name="firstName" id="firstName" onChange={this.onAltLoginFieldChange} />
					</label>
					<label>
						Etternavn
						<input type="text" name="lastName" id="lastName" onChange={this.onAltLoginFieldChange} />
					</label>
					{altError && <p className="error">{altError}</p>}
					<button className="lit-btn lit-btn--small" type="submit">Logg inn</button>
				</form>
			</div>
		);
	
		return (
			<div className="Login">
				<header className="lit-header">
					<h1 className="lit-logo">
						<img className="lit-logo__img" src={Logo} alt="literate logo" />
					</h1>
				</header>
	
				<div className="lit-wrapper--article text-center">
					<h2>Innlogging</h2>
	{this.state.showReuseBanner && (
						<div className="lit-reuse-banner" role="status" aria-live="polite">
				    <div className="lit-reuse-banner__dot" aria-hidden="true" />
    <div>
		<strong>OBS:</strong>{' '}
      Denne testnøkkelen ser ut til å ha blitt startet nylig
      {typeof this.state.reuseSignal?.minutesSinceUsed === 'number' &&
        <> ({this.formatSince(this.state.reuseSignal.minutesSinceUsed)})</>
      }.
	<br />
	<span>
        Vennligst forsikre dere om at <u>riktig kandidat</u> fortsetter en påbegynt test.
        Hvis dette er en <u>ny kandidat</u>, bør dere be en administrator om en ny testnøkkel.
      </span>
	   </div>
	        <button
		      type="button"
		      onClick={this.dismissReuseBanner}
		      className="lit-reuse-banner__close"
		      aria-label="Skjul varsel"
		      title="Skjul"
		    >
		      ×
		    </button>			
			</div>
	)}
					{!bootstrapping && isNorming && !requiresVerification && (
						<p>Du må logge inn med pinkode før du kan starte testen.</p>
					)}
	
					{!bootstrapping && !isNorming && !this.state.showReuseBanner && !requiresVerification && (
						<p>
							<span>Velg om du ønsker å logge inn med Feide eller pinkode.</span><br />
							<span>Spør gjerne en voksen om hjelp.</span><br />
						</p>
					)}
	
					{!bootstrapping && isNorming && !requiresVerification && !passwordLogin && (
						<div className="bank-id-type-selector-wrapper">
							<br />
							<button
								className="lit-btn lit-btn--small bg-secondary"
								onClick={() => this.reAffirmTestKeyInfo(testKey)}
							>
								Pinkode
							</button>
						</div>
					)}
	
					{canShowChoiceButtons &&
						renderFeidePincodeButtons()}
	
					{renderErrorOrInstructions()}
	
					<p className="lit-thirdPCsupport" id="result" />
	
					<div className="lit-thrid-party-settings">
						<p style={styles.thirdPartyMessage}>
							<span style={{ color: 'Red' }}>
								<b><span id="lit-site-warning" /></b>
							</span>
							<em><span id="lit-site-warning_text" /></em>
							<a
								target="_blank"
								rel="noopener noreferrer"
								href="https://www.dysmate.no/advarsel-2/"
							>
								<u style={{ color: 'Lime' }}>
									<span id="lit-site-settings-instructions" />
								</u>
							</a>
							<em><span id="lit-site-warning_text_end" /></em>
						</p>
					</div>
	
					{showIframe && !isFeide && (
						<div className="bank-id-iframe-wrapper">
							<iframe
								title="login-frame"
								frameBorder="0"
								id="authFrame"
								scrolling="no"
								src={iframeUrl}
								style={{ height: '600px', width: '100%' }}
							/>
						</div>
					)}
	
					{showCustomLogin && (
  <div className="lit-customlogin-sub-wrapper">
    <CustomLogin
      email={email}
      pinCode={pinCode}
      childSelfStarting={childSelfStarting}
    />
  </div>
)}
	
					{showError && <div>{error}</div>}
	
					{showAltLogin && renderAltLoginForm()}
	
					{showCoockieDetectionFrame && (
						<div>
							<iframe
								src="https://mindmup.github.io/3rdpartycookiecheck/start.html"
								style={{ display: 'none' }}
							/>
						</div>
					)}
				</div>
			</div>
		);
	}
	
}

const mapStateToProps = (state) => {
	const {error, iframeUrl, isInit} = state.auth;

	return {
		error,
		iframeUrl,
		isInit,
	};
};

const mapDispatchToProps = {
	initAuth: initAuthAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
